<section class="checkbox-grid">
  <checkbox-grid-header
    [gridTitle]="gridTitle"
    [headerCells]="headerCells"
    (bulkUpdated)="onBulkUpdate($event)"
    [isBulkSupported]="isBulkSupported"
  >
  </checkbox-grid-header>

  @if (ownRows) {
    <checkbox-row-wrapper>
      @for (row of ownRows; track row) {
        <div class="checkbox-grid__row-wrapper">
          <checkbox-row
            [row]="row"
            [isReadOnly]="isReadOnly"
            (rowUpdated)="onRowUpdated($event)"
          >
          </checkbox-row>
        </div>
      }
    </checkbox-row-wrapper>
  }
</section>
